<his-documentation-link
	[target]="moduleOptions.DOCUMENTATION_ARTICLE"
	[title]="moduleOptions.DOCUMENTATION_TITLE">
</his-documentation-link>

<!-- delete confirmation dialog -->
<res-confirmation-dialog></res-confirmation-dialog>
<!-- andere confirmation-Dialoge -->
<res-confirmation-dialog header="fs.res.common.confirmation.warn" [key]="CONFIRM_BACK_TO_CHILD_DIALOG_KEY"></res-confirmation-dialog>
<res-confirmation-dialog header="fs.res.common.confirmation.warn" [key]="CONFIRM_SAVE_DESPITE_DUPLICATE_DIALOG_KEY"></res-confirmation-dialog>

<!-- res information dialog - record can not be deleted due to connections in other objects -->
<res-information-dialog></res-information-dialog>

<h1 *ngIf="publication && publication.id; else new">{{ (!childPublication ? 'fs.res.publication.edit' : 'fs.res.publication.Publication.parent.edit') | hisUi}}</h1>
<ng-template #new>
	<h1>{{ (!childPublication ? 'fs.res.publication.search.create' : 'fs.res.publication.Publication.parent.create') | hisUi}}</h1>
</ng-template>
<!--  beim Anlegen nur Typ-Auswahl :  (onChange)="selectPublicationType($event.value)"-->
<div class="layoutBlock" *ngIf="!publicationId && isInitialPublicationType">
	<div class="columnHalf">
		<div class="clearAndSpace"></div>
		<p-panel [header]="'I18nValue.basicData' | hisUi">
			<his-plam>
				<p-autoComplete *ngIf="!childPublication?.publicationType.hiskeyId" #content hisDdKey="fs.res.publication.Publication.publicationType"
					[(ngModel)]="publication.publicationType" hisEagerDataSource="publicationTypeValue"
					(onSelect)="setInitialPublicationType(false)">
				</p-autoComplete>
                <p-autoComplete *ngIf="childPublication?.publicationType.hiskeyId" #content hisDdKey="fs.res.publication.Publication.publicationType" [ignoreDefaultValue]="true"
					[(ngModel)]="publication.publicationType" [hisEagerDataSource]="'api/v1/fs/res/publication/publicationTypes?child=' + childPublication.publicationType.id"
					(onSelect)="setInitialPublicationType(false)">
				</p-autoComplete>
			</his-plam>
			<br>
			<div>
				<a class="transparent" routerLink="/pub/search" [queryParams]="{configFile: 'fs/res/searchPublication.xml'}" hisImage="magnifier" routerLinkActive="active">{{'fs.res.publication.search.data' | hisUi}}</a>
				<br>
			</div>
		</p-panel>
		<br>

		<p-panel [header]="'fs.res.publication.create.infoHeader' | hisUi">
			<div [innerHTML]="'fs.res.publication.create.infoMessage' | hisUi"></div>
		</p-panel>
	</div>
</div>

<div *ngIf="publication && !isInitialPublicationType">
	<his-dialog-header
        #dialogHeader
		[showSaveButton]="isAdmin() && !changeRequestExists()"
		[showDraftSaveButton]="isUserEditMode()"
		[showDraftDeleteButton]="showDeleteButton && isUserEditMode() && !!publication.id"
		[showCustomButton]="isUserEditMode() || (isAdmin() && changeRequestExists())"
        [showResetButton]="isUserEditModeOrAdmin()"
		[customButtonLabel]="changeRequestExists() ? 'fs.res.common.acceptChanges' : 'fs.res.common.forwardValidation'"
		[customButtonClass]="'button_highlighted_dark_green'"
		[customButtonImage]="'ARROW_RIGHT_FAT'"
		[showSearchButton]="showSearchButton"
		[showBackButton]="showBackButton && !childPublication?.publicationType.defaulttext"
		(save)="savePublication()"
		(saveDraft)="savePublicationAsDraft()"
		(deleteDraft)="deletePublication()"
		(customEvent)="isAdmin() ? savePublication() : savePublicationForValidation()"
		(resetInputs)="reset()">
        <ng-container customButtons>
            <button *ngIf="prevPage === 'duplicates'" type="button" [title]="'cs.sys.duplicates.check.backToDuplicatesPage' | hisUi" (click)="back()">{{'cs.sys.duplicates.check.backToDuplicatesPage' | hisUi}}</button>
            <button *ngIf="prevPage === 'importCandidates'" type="button" [title]="'fs.res.publication.import.candidates.back' | hisUi" (click)="backToSearchResult()">{{'fs.res.publication.import.candidates.back' | hisUi}}</button>
            <button *ngIf="childPublication?.publicationType.defaulttext" (click)="confirmBackNavigation()"><span>{{'fs.res.publication.Publication.backToChild' | hisUi:childPublication?.publicationType.defaulttext }}</span></button>
        </ng-container>
		<ng-container dataBox *ngIf="publication">
			<span id="publication_title" title="{{'fs.res.publication.Publication.title'|hisUi}}"><strong>{{publication.title}}</strong></span>
			| <span class="singleLine" id="publication_title2" title="{{'fs.res.publication.Publication.releaseYear'|hisUi}}">{{publication.releaseYear}}</span>
			| <span class="singleLine" id="publication_title3" title="{{'fs.res.publication.Publication.subtitle'|hisUi}}">{{publication.subtitle}}</span>
		</ng-container>

	 	<ng-container elementsRight>
			<his-translation-selector [defaultLanguage]="publication.languages[0]"></his-translation-selector>
		</ng-container>
	</his-dialog-header>
   <br/>

	<!-- Tabs -->
	<p-tabView id="tabView"  #tabData [(activeIndex)]="selectedTabIndex" (onChange)="tabChanged($event.index)" >
        <ng-container *ngFor="let tab of tabMenuItems; let i = index">
            <ng-container *ngIf="!tab.isDynamic; else dynamicTab">
			    <p-tabPanel lazy="true" [header]="tab.i18nKey|hisUi">
			        <res-info-panel [i18nKey]="tab.i18nKey" [target]="'publication'"></res-info-panel>
			        <ng-template pTemplate="header">
                        <div *ngIf="tab.showHeaderIcon"><img title="{{'fs.res.common.changesRequested' | hisUi }} {{tab.i18nKey | hisUi }}" hisImage="{{getHisImageName(tab.i18nKey)}}" class="inlineicon tabIcon"></div>
                        <span>{{ tab.i18nKey | hisUi }}</span>
                    </ng-template>
			       <!-- basic-data -->
			        <div *ngIf="tab.i18nKey === 'fs.res.common.mainData'">
			       		<res-publication-data-tab [publication]="publication" [childPublication]="childPublication" (publicationTypeChange)="onPublicationTypeChange($event)"
			       			[hisDynamicContent]="'fs.res.common.mainData'" [dynamicComponent]="publication._dynamicComponent"
                            [publicationTypeChildParentMap]="publicationTypeChildParentMap"
                            [changeRequestValueGroup]="changeRequestValueGroup"
                            (duplicatesByTitleChange)="onDuplicatesByTitleChange($event)"
                            (duplicatesByIdentifierChange)="onDuplicatesByIdentifierChange($event)"
                            (navigationLastUrlChange)="onNavigationLastUrlChange($event)"
                            (navigateToCreateParentOnNextSave)="navigateToCreateParentOnNextSave =$event"
                            (navigateToEditParentOnNextSave)="navigateToEditParentOnNextSave = $event">
			       		</res-publication-data-tab>
					</div>
					<!-- abstract -->
					<div *ngIf="tab.i18nKey === 'fs.res.publication.abstract'">
       					<res-publication-abstract-tab [publication]="publication"
       						[hisDynamicContent]="'fs.res.publication.abstract'" [dynamicComponent]="publication._dynamicComponent">
       					</res-publication-abstract-tab>
					</div>
					<!-- classification -->
					<div *ngIf="tab.i18nKey === 'fs.res.common.classifications'">
						<res-publication-classification-tab [publication]="publication"
							[hisDynamicContent]="'fs.res.common.classifications'" [dynamicComponent]="publication._dynamicComponent" [changeRequestValueGroup]="changeRequestValueGroup">
						</res-publication-classification-tab>
					</div>
                    <!-- documents -->
					<div *ngIf="tab.i18nKey === 'fs.res.common.documents'">
						<res-publication-documents-tab *ngIf="isDocumentsPanelVisible()" [publication]="publication" [hisDynamicContent]="'fs.res.common.documents'" [dynamicComponent]="publication._dynamicComponent">
						</res-publication-documents-tab>
					</div>
					<!-- research -->
					<div *ngIf="tab.i18nKey === 'fs.res.common.research'">
					   <res-research-tab
				            [(projects)]="publication.projects"
				            [dynamicComponent]="publication._dynamicComponent"
				            [hisDynamicContent]="'fs.res.common.research'"
				            [dDKeyResearchInfrastructures]="'fs.res.researchInfrastructure.ResearchInfrastructures'"
				            [dDKeyProject]="'fs.res.publication.Publication.projects'"
				            [customContentPanel]="true"
				            [(researchInfrastructures)]="publication.researchInfrastructures"
				            (onBeforeNavigate)="onBeforeNavigate()">
				            <res-funding-program-panel customContentPanel
					            [projects]="publication.projects"
					            [(fundingPrograms)]="publication.fundingPrograms">
					        </res-funding-program-panel>
				        </res-research-tab>
					</div>
				   </p-tabPanel>
			</ng-container>

			<!-- dynamic content -->
		    <ng-template #dynamicTab>
				<p-tabPanel lazy="true" *ngIf="hisBaseGlobalsService.isAnyModuleActive('HISINONERES')" [header]="tab.i18nKey|hisUi">
				 	<ng-template pTemplate="header">
                        <div *ngIf="tab.showHeaderIcon"><img title="{{'fs.res.common.changesRequested' | hisUi }} {{tab.i18nKey | hisUi }}" hisImage="{{getHisImageName(tab.i18nKey)}}" class="inlineicon tabIcon"></div>
			        	<span>{{ tab.i18nKey | hisUi }}</span>
			        </ng-template>
					<res-dynamic-tab-container
	                    [objectDynamicContent]="publication"
	                    [reloadTrigger]="reloadTrigger"
	                    [hisDynamicContent]="tab.i18nKey"
	                    [dynamicComponent]="publication._dynamicComponent"
	                    [target]="'publication'">
                    </res-dynamic-tab-container>
				 </p-tabPanel>
		    </ng-template>
	    </ng-container>
	</p-tabView>
</div>
